import script from "./NewRow.vue?vue&type=script&setup=true&lang=js"
export * from "./NewRow.vue?vue&type=script&setup=true&lang=js"

import "./NewRow.vue?vue&type=style&index=0&id=e244de5c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e244de5c"]])

export default __exports__